














import { Component, Vue } from 'vue-property-decorator';
import store, { ActionsTypes, GettersTypes } from '@/store';
import CreateTenant from './CreateTenant.vue';

@Component({
  components: { CreateTenant },
})
export default class SelectTenant extends Vue {
  tenantList: Array<string> = [];

  isLargeScreen() {
    return this.$vuetify.breakpoint.smAndUp;
  }

  async created() {
    this.tenantList = store.getters[GettersTypes.GET_TENANT_LIST];
  }
  get selectedTenant() {
    return store.getters[GettersTypes.GET_SELECTED_TENANT];
  }

  set selectedTenant(value: string | null) {
    store.dispatch(ActionsTypes.SET_SELECTED_TENANAT, value);
  }
}
